import { useDispatch } from 'react-redux';
import { useCallback, useMemo } from 'react';
import { WithBillId, WithScope } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Container, Dialog } from '@optimus-web/core';
import { DEFAULT_PORTAL_ID } from '@mews-commander/constants';
import { BillingMode } from '../constants';
import { openItemAssignmentDialog } from '../ducks/itemAssignment';
import { DialogFunctionsContext } from './ItemAssignmentDialogContent/context';
import { ItemAssignmentDialogContent } from './ItemAssignmentDialogContent';

interface ItemAssignmentDialogProps extends WithScope, WithBillId {
    active: boolean;
    loading: boolean;
    accountIds: string[];
    close(): void;
    orderItemIds?: string[];
    billingMode: BillingMode;
}

export const ItemAssignmentDialog = ({
    active,
    accountIds,
    close,
    loading,
    scope,
    billId,
    orderItemIds,
    billingMode,
}: ItemAssignmentDialogProps) => {
    const dispatch = useDispatch();

    const handleOpenDialog = useCallback(
        () => dispatch(openItemAssignmentDialog({ billId, scope, orderItemIds })),
        [dispatch, billId, orderItemIds, scope]
    );

    const dialogFunctions = useMemo(
        () => ({
            open: handleOpenDialog,
            close,
        }),
        [handleOpenDialog, close]
    );

    return (
        <Dialog
            active={active}
            loading={loading}
            onClose={close}
            size="large"
            title={<LocalizedText textKey={TextKey.WhereToMoveItems} />}
            portalContainerId={DEFAULT_PORTAL_ID}
        >
            <Container maxHeight="70vh">
                <DialogFunctionsContext.Provider value={dialogFunctions}>
                    <ItemAssignmentDialogContent accountIds={accountIds} billingMode={billingMode} scope={scope} />
                </DialogFunctionsContext.Provider>
            </Container>
        </Dialog>
    );
};
